import React, { useCallback, useEffect, useState } from 'react'
import { Grid, Box } from '@material-ui/core'
import { connect } from 'react-redux'

import { selectTeam } from '../redux/selectors/teamSelectors'
import { updateTeamSettingsStart } from '../redux/modules/team'
import Header from '../components/teams/admin/Header'
import CardTeamDetails from '../components/teams/admin/CardTeamDetails'
import CardPaymentDetails from '../components/teams/admin/CardPaymentDetails'
import CardBillingHistory from '../components/teams/admin/CardBillingHistory'
import CardAccountSettings from '../components/teams/admin/CardAccountSettings'
import DialogPaymentSelect from '../components/teams/admin/DialogPaymentSelect'
import { publishViewedManageAccountPage } from '../util/events/teamsEventPublishers'

const PageTeamAccount = ({ updateTeamSettingsStart, isLoadingTeam, team }) => {
  const [paymentOpen, setPaymentOpen] = useState(false)
  const openPaymentDialog = useCallback(() => setPaymentOpen(true), [setPaymentOpen])

  const onSettingsSubmit = changes => {
    updateTeamSettingsStart(team.id, { ...team, ...changes })
  }

  useEffect(() => {
    publishViewedManageAccountPage()
  }, [])

  return (
    <>
      <Header />
      <Box mt={3}>
        <Grid container spacing={2} justify="flex-start">
          <Grid item xs={12} md={8}>
            <CardTeamDetails team={team} loading={isLoadingTeam} onSubmit={onSettingsSubmit} />
            <CardAccountSettings team={team} loading={isLoadingTeam} onSubmit={onSettingsSubmit} />
            <CardBillingHistory />
          </Grid>
          <Grid item xs={12} md={4}>
            <CardPaymentDetails
              team={team}
              loading={isLoadingTeam}
              onBtnClick={openPaymentDialog}
            />
          </Grid>
        </Grid>
      </Box>
      <DialogPaymentSelect team={team} open={paymentOpen} onClose={() => setPaymentOpen(false)} />
    </>
  )
}

const mapStateToProps = state => {
  return {
    isLoadingTeam: state.team.isLoadingTeam,
    team: selectTeam(state),
  }
}

const mapDispatchToProps = {
  updateTeamSettingsStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTeamAccount)
